module.exports = __webpack_public_path__ + "static/img/fire_2.f6574a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/fire_2.png
// module id = 0E9M
// module chunks = 1